<template>
  <div class="circle">
    <span class="emoji">{{ emoji }}</span>
  </div>
</template>

<script setup>
import { defineProps } from "vue";

defineProps({
  emoji: String,
});
</script>

<style scoped>
.circle {
  /* Figma */
  width: 130px;
  height: 130px;
  border-radius: 50%;
  background: var(--Background);
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 32px;
  flex-shrink: 0;
}

.emoji {
  /* Figma */
  color: #000;
  font-family: Nunito;
  font-size: 53.377px;
  font-style: normal;
  font-weight: 900;
  line-height: 100%; /* 53.377px */
}
</style>
